import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { memo, useCallback } from 'react';
import Popup from '@atlaskit/popup';
import { DateRange } from './date-range';
import DateRangePickerContent from './date-range-picker-content';
export var DateRangePicker = /*#__PURE__*/memo(function (_ref) {
  var value = _ref.value,
    onChange = _ref.onChange,
    placeholder = _ref.placeholder,
    onClose = _ref.onClose,
    _ref$withTimeScale = _ref.withTimeScale,
    withTimeScale = _ref$withTimeScale === void 0 ? true : _ref$withTimeScale;
  var _React$useState = React.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    isOpen = _React$useState2[0],
    setIsOpen = _React$useState2[1];
  var _React$useState3 = React.useState(value),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    currentValue = _React$useState4[0],
    setCurentValue = _React$useState4[1];
  var togglePopup = useCallback(function () {
    if (isOpen) {
      onClose === null || onClose === void 0 || onClose();
    }
    setIsOpen(!isOpen);
  }, [isOpen, onClose]);
  var onDateChange = useCallback(function (newValue, confidence) {
    setCurentValue(newValue);
    onChange(newValue, confidence);
    setIsOpen(false);
    onClose === null || onClose === void 0 || onClose();
  }, [onChange, onClose]);
  var onClearDate = useCallback(function () {
    onDateChange();
  }, [onDateChange]);
  return /*#__PURE__*/React.createElement(Popup, {
    zIndex: 610,
    placement: "bottom-start",
    content: function content() {
      return /*#__PURE__*/React.createElement(DateRangePickerContent, {
        value: value,
        onChange: onDateChange,
        withTimeScale: withTimeScale
      });
    },
    isOpen: isOpen,
    onClose: onClose,
    shouldUseCaptureOnOutsideClick: true,
    trigger: function trigger(triggerProps) {
      return /*#__PURE__*/React.createElement(DateRange, {
        onClick: togglePopup,
        value: currentValue,
        placeholder: placeholder,
        triggerProps: triggerProps,
        onClearDate: onClearDate,
        withTimeScale: withTimeScale
      });
    }
  });
});